module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-77.ca3ef338.svg";